import React from "react";
import { Wrapper, ButtonWrapper } from "./styled";
import Button from "../Button";

function Cover({ onNext }) {
  return (
    <Wrapper>
      <ButtonWrapper>
        <Button light onClick={() => onNext()}>
          Играть
        </Button>
      </ButtonWrapper>
    </Wrapper>
  );
}

export default Cover;
